/* eslint-disable no-lone-blocks */
// @flow
import * as React from "react"
import { useRecoilValue, useSetRecoilState } from "recoil"
import { chatListSelector } from "../../../recoil/atoms/chats"
import { ChatBubble } from "./_chatBubble"
import layoutStates from "../../../recoil/atoms/layout"
import { useSessionStorage } from "../../../hooks/useSessionStorage"
import { Element } from "react-scroll"
import { ChatStyles } from "./index"
import { FadeChat } from "./_fadeChat"
import ChatVirtualizedList from "./ChatVirtualizedList"
import DaySplitter from "./_daySplitter"
import { withErrorBoundary } from "react-error-boundary"
import ComponentFallback from "src/components/common/errors/componentFallback"

interface ChatListProps {
  styleschat: ChatStyles
  chatApprovalRequired: boolean
  canSendChat: boolean
}

const _ChatList = withErrorBoundary(
  ({ styleschat, canSendChat, chatApprovalRequired }: ChatListProps) => {
    const allChatMessages = useRecoilValue(chatListSelector)
    const setFirstLoadChat = useSetRecoilState<boolean>(
      layoutStates.firstLoadChat
    )

    React.useEffect(() => {
      let firstLoad = setTimeout(() => {
        setFirstLoadChat(false)
      }, 1000)
      return () => clearTimeout(firstLoad)
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const { setSessionStorage } = useSessionStorage("reactions")

    return (
      <>
        {allChatMessages.length !== 0 && (
          <ChatVirtualizedList
            list={allChatMessages}
            scrollElementId="messages-container"
            renderItem={(message, index) =>
              message.id && (
                <ChatBubble
                  key={`key-${message?.id}`}
                  isFirstMessage={index === 0}
                  messageId={message.id}
                  styleschat={styleschat}
                  setSessionStorage={setSessionStorage}
                  canSendChat={canSendChat}
                  chatApprovalRequired={chatApprovalRequired}
                />
              )
            }
            renderDaySplit={date => (
              <DaySplitter styleschat={styleschat} date={date} />
            )}
          />
        )}
        {allChatMessages.length === 0 && <FadeChat />}
        <Element name={"chat-list-bottom"}>
          <div />
        </Element>
      </>
    )
  },
  {
    fallback: <ComponentFallback />
  }
)

export const ChatList = React.memo(_ChatList)
